import { render, staticRenderFns } from "./item-name.vue?vue&type=template&id=db3d2d9c&scoped=true&"
import script from "./item-name.vue?vue&type=script&lang=js&"
export * from "./item-name.vue?vue&type=script&lang=js&"
import style0 from "./item-name.vue?vue&type=style&index=0&id=db3d2d9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3d2d9c",
  null
  
)

export default component.exports